var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBubble24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.252 20.857a9.429 9.429 0 1 0-9.428-9.428c0 1.427.317 2.78.885 3.993L2.616 18.43c-.48 1.32-.72 1.981-.572 2.411.128.374.422.668.796.797.43.148 1.091-.092 2.412-.572l3.006-1.093a9.392 9.392 0 0 0 3.994.885Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble24);
export default __webpack_public_path__ + "static/media/bubble_24.c4e0ba33.svg";
export { ForwardRef as ReactComponent };